import { render, staticRenderFns } from "./searchModel.vue?vue&type=template&id=669b4e4c"
import script from "./searchModel.vue?vue&type=script&lang=js"
export * from "./searchModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports